import { IsDateInFuture, IsTodayWithinRange } from "./utils";

/**
 * The time stamp in MS when the maintenance is actually supposed to start
 */
const MAINTENANCE_START = 1670760000000; // December 11th, 2022 8am

/**
 * The time stamp in MS when the maintenance is actually supposed to end
 */
const MAINTENANCE_END = 1670785200000; // December 11th, 2022 3pm

/**
 * The message to be displayed in the login screen of each service
 */
export const SYSTEM_MAINTENANCE_MESSAGE = `The Business Licensing Platform will be unavailable on Sunday, December 11th, 2022 from 8am to 3pm for scheduled maintenance`

/**
 * The duration for which the login button should be blocked
 */
export const isMaintenanceModeOn = () => {
  return IsTodayWithinRange(MAINTENANCE_START, MAINTENANCE_END);
}

/**
 * The duration after which the maintenance message should not be 
 * displayed in the login screen
 */
export const isPastMaintenanceMode = () => {
  return !IsDateInFuture(MAINTENANCE_END)
}
